"use client";

import Image from "next/image";
import type { FC } from "react";

// Static list of logo filenames in the public/images/insuranceLogos folder
const availableLogoIcons = [
  "Aetna.svg",
  "Cigna.svg",
  "Humana.svg",
  "Oscar.svg",
];
const availableLogoImages = [
  "Payer_Aetna.svg",
  "Payer_Ambetter.svg",
  "Payer_American_Family.svg",
  "Payer_Anthem.svg",
  "Payer_BCBS.svg",
  "Payer_Cigna.svg",
  "Payer_HCSC.svg",
  "Payer_Healthnet.svg",
  "Payer_Humana.svg",
  "Payer_Oscar.svg",
  "Payer_Independent_Health.svg",
  "Payer_KaiserPermanente.svg",
  "Payer_Molina.svg",
  "Payer_Oscar.svg",
  "Payer_UnitedHealthcare.svg",
];

type Props = {
  insuranceName: string;
  className?: string;
  alt?: string;
  icon?: boolean;
};

export const InsuranceLogo: FC<Props> = ({
  insuranceName,
  className,
  alt,
  icon = true,
}) => {
  // Default fallback image
  if (!insuranceName) {
    return (
      <Image
        src="/images/insuranceLogoIcons/Default.svg"
        alt={alt ?? insuranceName}
        width={60}
        height={60}
        className={className}
      />
    );
  }
  const normalized = insuranceName.trim().toLowerCase();

  let matchedLogo: string | undefined;
  if (icon) {
    matchedLogo = availableLogoIcons.find((filename) =>
      filename.toLowerCase().includes(normalized),
    );
  } else {
    matchedLogo = availableLogoImages.find((filename) =>
      filename.toLowerCase().includes(normalized),
    );
  }

  if (icon) {
    const imageSrc = matchedLogo
      ? `/images/insuranceLogoIcons/${matchedLogo}`
      : "/images/insuranceLogoIcons/DefaultGray.svg";
    return (
      <Image
        src={imageSrc}
        alt={alt ?? insuranceName}
        width={60}
        height={60}
        className={className}
      />
    );
  }

  if (!icon && !matchedLogo) return null;
  if (!icon && matchedLogo) {
    return (
      <Image
        src={`/images/insuranceLogoImages/${matchedLogo}`}
        alt={alt ?? insuranceName}
        width={80}
        height={80}
        className={className}
      />
    );
  }
};
